import api from './api';

export interface TestConnectionResponse {
    success: boolean;
    message: string;
}

/**
 * WhatsApp Configuration Service
 */
export const whatsappService = {
    /**
     * Test WhatsApp API connection
     * NOTE: Requires backend endpoint GET /api/whatsapp/config/test/
     */
    async testConnection(): Promise<TestConnectionResponse> {
        try {
            const response = await api.get('/whatsapp/config/test/');
            return {
                success: true,
                message: response.data.message || 'Conexão estabelecida com sucesso'
            };
        } catch (error: any) {
            return {
                success: false,
                message: error.response?.data?.message || error.response?.data?.error || 'Falha ao testar conexão'
            };
        }
    }
};

export default whatsappService;
